import React from 'react';
import styled from 'styled-components';
import { FaFilm, FaPhotoFilm, FaChessRook, FaCommentDots, FaForwardFast, FaHighlighter } from "react-icons/fa6";

const cardData = [
  {
    prompt: 'Subtitles and Translation',
    title: 'We take a humanized approach when developing our client\'s optimization and testing programs. Our creative team is capable of translating the language you require. Our recent projects of Subtitling include Urdu, Hindi, Arabic, English, French, and Mandarin for top-notch Feature Films and Corporate Videos.',
    icon: <FaCommentDots />
  },
  {
    prompt: 'Producing',
    title: 'We oversee film production from selecting the script, hiring a director, crew, and coordinating the post-production process along with the marketing and distribution.',
    icon: <FaChessRook />
  },
  {
    prompt: 'Event Planning',
    title: 'We organize the events like no other. Our Event team can plan any event in Dubai, Abu-Dhabi, and Sharjah. We have done multiple Corporate Event planning be it on a large stadium, auditorium, or even on a Cruise Ship.',
    icon: <FaPhotoFilm  />
  },
  {
    prompt: 'Film and Video Direction',
    title: 'Our envisioned directors have a keen eye on all the aspects of the film or video production process. Our range of skillful directors can direct Films of all genres. Our in-house directors have also bagged awards from International Film Festivals around the globe. The team consists of the best from UAE, Pakistan, India, Norway, Poland, USA, UK, and Lebanon',
    icon: <FaFilm  />
  },
  {
    prompt: 'Sound Recording',
    title: "The one department on which our clients merely focuses, but this is the one single thing that can make or break your film. That is the reason there are only a handful of Sound Recordists available in the industry. But don't worry we have got you covered.",
    icon: <FaForwardFast />
  },
  {
    prompt: 'Screenwriting',
    title: 'Our creative team is the core of everything that we do. We provide Screenwriting services from researching the story, building the narrative, writing the story, script and screenplay.',
    icon: <FaHighlighter />
  }
];

const Card = ({ prompt, title, icon }) => {
  return (
    <Container className="container">
      <Canvas>
        {[...Array(25)].map((_, index) => (
          <Tracker key={index} className={`tr-${index + 1}`} />
        ))}

        <CardContent id="card">
        <IconWrapper>{icon}</IconWrapper>
          <Prompt id="prompt">{prompt} </Prompt>
          <Title className="title">{title}</Title>
        </CardContent>
      </Canvas>
    </Container>
  );
};

const CardContainer = () => {
  return (
    <Wrapper>
      {cardData.map((data, index) => (
        <Card key={index} prompt={data.prompt} title={data.title} icon={data.icon} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  padding: 50px;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 10px;

  @media only screen and (max-width: 1024px) {
    padding: 30px;
    gap: 15px;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
    gap: 10px;
    justify-content: center;
  }
`;

const Container = styled.div`
  position: relative;
  width: 30%;
  height: 254px;
  transition: 200ms;
  background: linear-gradient(#000, var(--secondary-background-color))
      padding-box,
    linear-gradient(
        145deg,
        transparent 35%,
        var(--secondary-color),
        var(--secondary-color)
      )
      border-box;
  border: 2px solid transparent;
  border-radius: 16px;

  &:hover {
    cursor: pointer;
  }

  &:active {
    width: 500px;
    height: 245px;
  }

  @media only screen and (max-width: 1024px) {
    width: 45%;
    height: 230px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

const Canvas = styled.div`
  perspective: 800px;
  inset: 0;
  z-index: 200;
  position: absolute;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 0;
`;

const CardContent = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 20px;
  transition: 700ms;
`;

const Prompt = styled.p`
  bottom: 8px;
  left: 12px;
  text-align: center;
  z-index: 20;
  font-size: 26px;
  font-weight: bold;
  transition: 300ms ease-in-out;
  max-width: 1000px;
  color: #fff;

  @media only screen and (max-width: 1024px) {
    font-size: 24px;
  }

  @media only screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const Title = styled.p`
  opacity: 0;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
  transition-delay: 100ms;
  position: absolute;
  font-size: 14px;
  color: #fff;
  margin-right: 10px;
  margin-left: 10px;
  padding: 0 10px;
  text-align: center;
   letter-spacing: 1.1px;

  @media only screen and (max-width: 1024px) {
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Tracker = styled.div`
  position: absolute;
  z-index: 200;
  width: 100%;
  height: 100%;

  &:hover ~ #card #prompt {
    opacity: 0;
  }

  &:hover ~ #card .title {
    opacity: 1;
  }

  &:hover ~ #card {
    transition: 300ms;
    filter: brightness(1.1);
  }
`;

const IconWrapper = styled.div`
  font-size: 40px;
  color: #fff;
  margin-bottom: 10px;
  transition: opacity 300ms ease;

  ${Container}:hover & {
    opacity: 0;
  }
`;

export default CardContainer;